import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const opsNotificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-ops-notifications',
	path: '/jira/settings/personal/alert-notifications',
};
